import { gql } from '@apollo/client';

export const FETCH_RMA_PAYMENT_RESPONSE = gql`
query GetRmaPaymentResponse($offset: Int, $limit:Int) {
    GetRmaPaymentResponse(offset:$offset, limit:$limit) {
        data {
            Message {
                BfsBenfId
                BfsBenfTxnTime
                BfsBfsTxnId
                BfsBfsTxnTime
                BfsDebitAuthCode
                BfsDebitAuthNo
                BfsMsgType
                BfsOrderNo
                BfsRemitterBankId
                BfsRemitterName
                BfsTxnAmount
                BfsTxnCurrency
                MembershipDurationId
                UserId
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;
export const FETCH_STRIPE_PAYMENT_RESPONSE = gql`
query GetStripePaymentResponse {
    GetStripePaymentResponse {
        data {
            Message {
                Amount
                CreatedAt
                MembershipDurationId
                Product
                Remarks
                Status
                TransactionId
                UpdatedAt
                UserId
            }
        }
        error {
            code
            field
            message
        }
    }
}
`;

export const FETCH_INAPP_PURCHASE_PAYMENT_RESPONSE = gql`
query GetInatePaymentResponse {
    GetInatePaymentResponse {
        data {
            Message {
                ID
                TransactionId
                Product
                PurchaseDate
                UserId
                MembershipDurationId
                Amount
                Status
            }
        }
        error {
            field
            message
            code
        }
    }
}

`;


